export const plural = (num: number, text: string, pluralText?: string) => {
  if (num === 1) {
    return text;
  }

  // by default will add "s" to the tail of the string, but can be replaced with
  // a passed value ie: "child", "children"
  return pluralText ?? `${text}s`;
};
